export default __webpack_public_path__ + "363521b2996f3138d439d5469fdca79f.png";